export default "__VITE_ASSET__DWBvfETw__"